module.exports = __webpack_public_path__ + "img/image_02.d24fb7a2.jpg";